export enum TabType {
  GENERAL = 'general',
  LOGICAL_PERMISSIONS = 'logicalPermissions',
  DATA_PERMISSIONS = 'dataPermissions',
  USERS = 'users'
}
